.BatchSelectionDataTableContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  user-select: none;
  overflow: hidden;
  scrollbar-width: none;
  margin-left: var(--space-sm);

  td > div:not([role="tooltip"]) span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media (max-width: 1024px) {
    margin-left: 0;
  }
}

.BatchSelectionDataTableFooter {
  margin-left: var(--space-sm);
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
  padding: var(--space-xs) 0 var(--space-xs);
}

.BatchSelectionDataTable {
  --first-group-column-padding-left: var(--space-xs);

  min-width: 100%;

  td {
    font-size: 0.9375rem;
  }

  tr:last-of-type:hover td {
    background: none;
  }

  .TableGroupHeader {
    width: 100%;
    border-right: none;
    box-shadow: none;
    padding-top: 0;
    padding-right: 0;
    padding-left: 0;
    padding-bottom: var(--space-lg);
  }

  .OutputsTableGroupHeader {
    min-width: max(calc(40vw - 240px), 350px);
  }

  .DeleteButtonCell,
  .DeleteButtonHeader {
    border-right: none;
    border-bottom: none;
    max-width: 30px;
    min-width: 30px;
    padding: 0;

    &[data-pinned="true"] {
      box-shadow: none;
    }
  }

  .DeleteButtonCell {
    .DeleteButtonContainer {
      display: grid;
      place-items: center;
      height: 44px;
      background-color: var(--white);
      border-radius: 22px 0 0 22px;
    }

    & > * {
      opacity: 0;
    }

    &:has(button:focus-visible) > * {
      opacity: 1;
    }
  }

  tr:hover .DeleteButtonCell {
    background-color: var(--white);

    .DeleteButtonContainer {
      opacity: 1;
      background-color: var(--bg);
    }
  }

  /* Delete button hover */
  tr:has(.DeleteButtonCell .DeleteButton:hover),
  tr:has(.DeleteButtonCell .DeleteButton:focus-visible) {
    .DeleteButtonCell {
      background-color: var(--white);
    }

    .DeleteButtonContainer,
    td {
      transition: background-color 0.1s;
      background-color: var(--accent-2-hover);
    }

    .EmptyCell {
      background-color: var(--white);
    }
  }

  .PipeSizeHeader:has([data-slot="column-actions"]) {
    min-width: 130px;
  }

  .EmptyHeader,
  .EmptyCell {
    max-width: 55px;
    min-width: 55px;
    width: 55px;
    border-right: none;
    border-bottom: none;
    box-shadow: none;
  }

  tr:hover .EmptyCell {
    background-color: var(--white);
  }

  tr:last-of-type > .DeleteButtonCell,
  tr:last-of-type > .EmptyCell {
    border-bottom: none;
  }

  .SuggestionNameCell {
    padding-top: 0;
    padding-bottom: 0;
    white-space: nowrap;
  }

  .SubProductCell {
    padding-top: var(--space-xs);
    padding-bottom: var(--space-xs);
  }

  .InputCell {
    max-width: 0;
  }

  /* First td with the class InputCell or OutputCell */
  tr > .InputCell:not(.InputCell ~ .InputCell),
  tr > .OutputCell:not(.OutputCell ~ .OutputCell) {
    padding-left: var(--first-group-column-padding-left);
  }

  /* First th with the class InputHeader or OutputHeader */
  tr > .InputHeader:not(.InputHeader ~ .InputHeader),
  tr > .OutputHeader:not(.OutputHeader ~ .OutputHeader) {
    padding-left: var(--first-group-column-padding-left);

    [data-slot="column-actions"] {
      padding-left: var(--first-group-column-padding-left);
    }
  }

  /* Last td or th with the class InputCell or InputHeader */
  tr > .InputCell:not(:has(~ .InputCell)),
  tr > .InputHeader:not(:has(~ .InputHeader)) {
    border-right: none;
  }

  @media (max-width: 1024px) {
    --first-group-column-padding-left: 2px;
    margin-left: var(--space-xs);
  }
}

.ConfirmationDialog {
  --dialog-padding: calc(var(--space-xxl) - 4px)
    calc(var(--space-xxl) * 2 - 12px) !important;
  --dialog-width: clamp(768px, 70vw, 1280px) !important;
  --dialog-height: clamp(768px, 60dvh, 1024px) !important;
}
